import EcoPagination from 'eco-design/base/eco-pagination';
import EcoBlogCard from 'eco-design/sections/eco-blog-items/eco-blog-card';
import GloLayout from 'lowcode/common/GloLayout';
import { useRouter } from 'next/router';
import { Fragment, useEffect, useState } from 'react';
import { queryBlogTagList, queryCategoryItems } from '../../common/blog-api/queryCategoryItems';
import BlogTimer from '../../common/blog-timer';
import { getBlogTagFromList } from '../../common/utils';
import './index.scss';

const INIT_NEWS_CATEGORY_TAGS = ['website-news', 'partnership-news', 'csr-news'];

export default function Content({ id, data, initIndex = 0, isEditStatus = false }: any) {
    const { total = 0, tagItems = [], items = [], pageNum = 1, isBlogIndex = false } = data;
    const { locale = 'us' } = useRouter();
    const [defaultPageSize, setDefaultPageSize] = useState(18);
    const [tagListA, setTagListA] = useState(tagItems || []);
    const [tagListAll, setTagListAll] = useState(tagItems || []);

    const [tagActiveKey, setTagActiveKey] = useState('');
    const [pageActive, setPageActive] = useState(pageNum);
    const [dataListA, setDataListA] = useState<any>(items);
    const [totalNum, setTotalNum] = useState(total);

    const router = useRouter();
    const pathname = router.pathname;
    let disablePage = false;
    if (pathname.includes('edit-blog')) {
        disablePage = true;
    }
    // tag 切换
    const tagChange = (item: any) => {
        setPageActive(1);
        if (isBlogIndex && item?.tagUrl === '') {
            location.href = `/${locale}/blog`;
            return;
        }
        setTagActiveKey(item?.tagUrl);
    };

    // 切换数据
    const getItemsForNone = async (categoryId: any, page: number) => {
        const condData: any = {};
        // if (categoryId && categoryId !== 'ALL') {
        //     condData.categoryId = categoryId;
        // }
        condData.categoryIds = categoryId?.length === 0 ? [] : categoryId;
        condData.page = page;
        const dataA = await queryCategoryItems(locale, condData);
        setDataListA(dataA.items);
        setPageActive(page);
        setTotalNum(dataA.total);
    };
    // 初始化 tag 列表
    const initTagHandle = async () => {
        const dataA = await queryBlogTagList(locale, {});
        const itemsA = dataA?.items || [];
        const finalTabList = itemsA?.filter((item: any) => {
            return !INIT_NEWS_CATEGORY_TAGS.includes(item.tagUrl);
        });
        if (!disablePage) {
            finalTabList.unshift({
                tagUrl: '',
                tag: 'ALL',
            });
        }

        setTagListA(finalTabList);
        setTagListAll(itemsA);
    };

    const handleDataChange = async () => {
        if (tagListAll.length === 0) return; // 等待tagListAll加载完成

        if (data?.categoryId?.length === 0) {
            setTagListA([]);
            setDataListA([]);
            setPageActive(1);
        } else {
            let blogTagIds = tagActiveKey == '' ? tagListAll?.filter((item: any) => item.tagUrl !== '').map((item: any) => item.tagUrl) : [tagActiveKey];
            if (Array.isArray(data.categoryId)) {
                if (data.categoryId.length > 0) {
                    // 过滤出所有匹配的标签
                    const selectedTags = tagListAll.filter((tag: any) => data.categoryId?.includes(tag.tagUrl));

                    // 如果找到了匹配的标签，可以进行相应处理
                    if (selectedTags.length > 0) {
                        const finalTags: any = disablePage ? [...selectedTags] : [{ tagUrl: '', tag: 'ALL' }, ...selectedTags];
                        setTagListA(JSON.parse(JSON.stringify(finalTags)));
                        blogTagIds = tagActiveKey == '' ? selectedTags.map((item: any) => item.tagUrl) : [tagActiveKey];
                    }
                }
            }
            await getItemsForNone(blogTagIds, pageActive);
        }
    };

    useEffect(() => {
        handleDataChange();
    }, [data?.categoryId, tagListAll, pageActive, tagActiveKey]);

    useEffect(() => {
        if (!tagItems.length) {
            initTagHandle();
        } else {
            const tagListB = JSON.parse(JSON.stringify(tagListA));
            const finalTabList = tagListB?.filter((item: any) => {
                return !INIT_NEWS_CATEGORY_TAGS.includes(item.tagUrl);
            });
            if (!disablePage) {
                finalTabList.unshift({
                    tagUrl: '',
                    tag: 'ALL',
                });
            }
            setTagListA(finalTabList);
            setTagListAll(finalTabList);
        }
    }, []);
    const pageChange = (page: number) => {
        setPageActive(page);
        if (isBlogIndex && tagActiveKey === '') {
            // 首页所有的时候不触发，直接跳转，由于a标签周围有小空白，却能点击，禁用这回掉了
            return;
        }
    };

    return (
        <GloLayout className="editor-blog-list-all" id={id}>
            <div className="editor-blog-list-all-tag">
                {tagListA?.map((item: any, index: number) => {
                    return (
                        <div
                            key={index}
                            onClick={() => {
                                tagChange(item);
                            }}
                            className={`editor-blog-list-all-tag-item${tagActiveKey === item.tagUrl ? ' editor-blog-list-all-tag-active' : ''}`}
                        >
                            {item.tag}
                        </div>
                    );
                })}
            </div>
            <div className="editor-blog-list-all-c eco-content">
                {dataListA?.map((item: any, index: number) => {
                    const thePage = JSON.parse(item.thePage || '{}');
                    const tagItem = getBlogTagFromList(item.blogTagList || [], tagActiveKey);
                    const categoryHref = tagItem.tagUrl ? `/${locale}/blog/category/${tagItem.tagUrl}` : undefined;

                    return (
                        <Fragment key={index}>
                            <EcoBlogCard
                                label={tagItem.tag}
                                title={thePage.blogTitle}
                                pc={thePage.blogImgPc}
                                h5={thePage.blogImgH5}
                                href={item.seoUrl}
                                categoryHref={categoryHref}
                                timer={BlogTimer(item.newFirstReleaseTime || item.firstReleaseTime, locale)}
                            />
                        </Fragment>
                    );
                })}
            </div>
            {/* 只有博客首页分类为all时，分页用跳转 */}
            {tagListA?.length !== 0 && total / defaultPageSize > 1 && (
                <EcoPagination
                    total={totalNum}
                    onChange={pageChange}
                    current={pageActive}
                    defaultPageSize={defaultPageSize}
                    isOpenLink={isBlogIndex && tagActiveKey === ''}
                    linkBefore={`/${locale}/blog/page/`}
                />
            )}
        </GloLayout>
    );
}
